module.exports = __webpack_public_path__ + "static/media/base.2992e1f8.jpg";